import { useState, forwardRef, useEffect } from "react";
import { TextField, Grid, InputAdornment } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  resetForm,
  Wallet,
  setReceiveCashSupplierDialog,
} from "../../../../../app/slices/walletSlice";
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { useParams } from "react-router";
import { HiOutlineArrowDownTray, HiOutlineBanknotes } from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../../components/FormDialog";

const NumericFormatCustom = forwardRef(function NumericFormatCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      valueIsNumericString
    />
  );
});

const ReceiveCashForm = () => {
  const { supplier_id } = useParams();
  const _ReceiveCashDialog = useSelector(
    (state) => state.wallet.receiveCashSupplierDialog
  );

  const [saving, setSaving] = useState(false);

  const { control, handleSubmit } = useForm({
    defaultValues: { amount: 0 },
  });

  const onSubmit = async (data) => {
    setSaving(true);
    data.supplier_id = supplier_id;
    try {
      await dispatch(Wallet.receiveCashSupplier(data));
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(setReceiveCashSupplierDialog());
  };

  return (
    <FormDialog
      open={_ReceiveCashDialog}
      onClose={handleClose}
      icon={<HiOutlineArrowDownTray />}
      title="استلام حساب الفواتير"
      subtitle="سجل المبلغ المستلم من المورد مع ملاحظاتك"
      onSubmit={handleSubmit(onSubmit)}
      saving={saving}
    >
      <SectionCard icon={<HiOutlineBanknotes />} title="تفاصيل الاستلام">
        <Grid item xs={12}>
          <Controller
            name="amount"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="المبلغ"
                fullWidth
                {...field}
                InputProps={{
                  inputComponent: NumericFormatCustom,
                  startAdornment: (
                    <InputAdornment position="start">IQD</InputAdornment>
                  ),
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name="note"
            control={control}
            render={({ field }) => (
              <TextField
                size="small"
                multiline
                rows={4}
                label="ملاحظات"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default ReceiveCashForm;
